<template>
<div class="d-inline">
    <v-form v-if="edit" v-model="valid" class="d-inline-flex" @submit="(e) => e.preventDefault()">
        <v-text-field v-model="v" :rules="rules" outlined dense hide-details autofocus @blur="cancel" @keyup.esc="cancel" @keyup.enter="emit" class="input">
            <template #append>
                <v-btn :disabled="v === value || !valid" icon small @click="emit" style="margin-right: -6px">
                    <v-icon small>mdi-check</v-icon>
                </v-btn>
                <v-btn icon small @click="cancel" style="margin-right: -6px">
                    <v-icon small>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-text-field>
    </v-form>
    <div v-else class="d-flex align-center">
        <router-link v-if="to" :to="to" class="value">{{value}}</router-link>
        <span v-else class="value">{{value}}</span>
        <v-icon small @click="edit = true" :disabled="disabled" class="ml-1">mdi-pencil-outline</v-icon>
    </div>
</div>
</template>

<script>
export default {
    props: {
        value: String,
        rules: Array,
        open: Boolean,
        to: Object,
        disabled: Boolean,
    },

    data() {
        return {
            v: this.value,
            edit: this.open,
            valid: false,
        }
    },

    methods: {
        emit() {
            if (this.valid) {
                this.$emit('input', this.v);
                this.edit = false;
            }
        },
        cancel() {
            this.edit = false;
            this.$emit('cancel');
        },
    },
}
</script>

<style scoped>
.input {
    max-width: 16ch;
}
.value {
    max-width: 16ch;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>